import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var _templateObject;
const SvgComponent = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M47.128 9.2c-4.135-.114-7.712 3.103-7.828 7.373V16.717c-3.536-.57-7.218 1.373-8.449 5.067l-.012.036-.01.038-.044.175c-.18.708-.385 1.52-.285 2.52v16.152c-2.902-.93-6.116-.413-8.525 1.514l-.012.01-.012.01c-3.783 3.227-4.496 8.844-1.323 12.697l.03.037.208.207 4.784 5.581.009.01c2.845 3.14 5.304 6.58 7.474 10.228C36.813 77.61 43.644 81.6 51.2 81.6c5.471 0 10.624-2.21 14.407-5.993 3.99-3.99 6.188-9.339 6.293-14.989V26.613c.107-4.132-3.007-7.582-7.246-7.811l-.027-.002H64.6c-.484 0-.968.033-1.45.1-.415-3.704-3.364-6.693-7.323-6.8H55.8c-.889 0-1.82.118-2.685.423-1.35-2.032-3.537-3.22-5.973-3.322h-.014zm-.92 6.707c.091-.092.253-.203.453-.29.178-.077.323-.109.406-.116.72.085 1.182.674 1.136 1.216l-.003.041V40.2a3.22 3.22 0 003.2 3.2 3.22 3.22 0 003.2-3.2V19.6c0-.634.53-1.177 1.16-1.2.725.082 1.189.673 1.144 1.217l-.004.041V41.9a3.22 3.22 0 003.2 3.2 3.22 3.22 0 003.2-3.2V26.4c0-.648.552-1.2 1.2-1.2.705 0 1.26.592 1.203 1.323l-.003.039V60.4c0 3.896-1.766 7.655-4.516 10.502-5.405 5.495-14.367 5.504-19.88.088a14.176 14.176 0 01-2.424-3.264l-.006-.012-.007-.013c-2.33-4.051-4.968-7.806-8.116-11.361l-.002-.003-4.793-5.492-.002-.001c-.912-1.055-.882-2.662.116-3.702.093-.056.196-.136.287-.249.52-.34.971-.493 1.443-.493a3.1 3.1 0 012.349 1.06l1.26 1.455 5.49 7.884.02.026c.27.336.64.676 1.08.922.42.236.966.418 1.568.352.528-.01 1.222-.147 1.82-.589 1.471-1.041 1.724-3.067.732-4.483L37.1 45.883V24.2c0-.769.566-1.3 1.1-1.3.648 0 1.2.552 1.2 1.2v14.1a3.22 3.22 0 003.2 3.2 3.22 3.22 0 003.2-3.2V16.7c0-.263.11-.547.325-.72l.043-.034.04-.039z",
      stroke: "none"
    })]
  });
};
const IconHand = /*#__PURE__*/styled(SvgComponent).withConfig({
  displayName: "Hand__IconHand",
  componentId: "sc-snu2am-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  vertical-align: middle;\n"])));

export { IconHand };
